import React from 'react';
import ReactDOM from 'react-dom';
import { EquiposApp } from './EquiposApp';

import './styles.css';


ReactDOM.render(
    <EquiposApp />,
  document.getElementById('root')
);

